if (!customElements.get('vn-showcase')) {
  customElements.define(
    'vn-showcase',
    class VnShowcase extends HTMLElement {
      connectedCallback() {
        this.tabs = [...this.querySelectorAll('[role="tab"]')];
        this.panels = [...this.querySelectorAll('.vn-showcase__panel')];
        this.arrows = [...this.querySelectorAll('.vn-showcase__arrow')];
        this.onScroll = this.onScroll.bind(this);

        this.tabs.forEach((tab, index) => {
          tab.addEventListener('click', () => this.select(index));
          tab.addEventListener('keydown', (event) => this.onTabKeydown(event, index));
        });
        this.arrows.forEach((arrow) =>
          arrow.addEventListener('click', () => this.scrollByCard(Number(arrow.dataset.direction)))
        );
        this.panels.forEach((panel) => {
          panel.querySelector('.vn-showcase__track')?.addEventListener('scroll', this.onScroll, { passive: true });
        });
        this.update();
      }

      get activeTrack() {
        return this.panels.find((panel) => !panel.hidden)?.querySelector('.vn-showcase__track');
      }

      select(index) {
        this.tabs.forEach((tab, i) => {
          const selected = i === index;
          tab.setAttribute('aria-selected', String(selected));
          tab.tabIndex = selected ? 0 : -1;
        });
        this.panels.forEach((panel, i) => (panel.hidden = i !== index));
        const track = this.activeTrack;
        if (track) track.scrollLeft = 0;
        this.update();
      }

      onTabKeydown(event, index) {
        if (event.key !== 'ArrowRight' && event.key !== 'ArrowLeft') return;
        event.preventDefault();
        const next = (index + (event.key === 'ArrowRight' ? 1 : -1) + this.tabs.length) % this.tabs.length;
        this.select(next);
        this.tabs[next].focus();
      }

      scrollByCard(direction) {
        const track = this.activeTrack;
        const item = track?.querySelector('.vn-showcase__item');
        if (!track || !item) return;
        const gap = parseFloat(getComputedStyle(track).columnGap) || 0;
        track.scrollBy({ left: direction * (item.offsetWidth + gap), behavior: 'smooth' });
      }

      onScroll() {
        if (this.ticking) return;
        this.ticking = true;
        requestAnimationFrame(() => {
          this.ticking = false;
          this.update();
        });
      }

      update() {
        const track = this.activeTrack;
        if (!track) return;
        const max = track.scrollWidth - track.clientWidth;
        const visible = track.scrollWidth ? track.clientWidth / track.scrollWidth : 1;
        const progress = max > 0 ? visible + (1 - visible) * (track.scrollLeft / max) : 1;
        const panel = track.closest('.vn-showcase__panel');
        panel?.querySelector('.vn-showcase__progress')?.style.setProperty('--vn-progress', `${Math.round(progress * 100)}%`);
        const [prev, next] = this.arrows;
        if (prev) prev.disabled = track.scrollLeft <= 2;
        if (next) next.disabled = track.scrollLeft >= max - 2;
      }
    }
  );
}
